module.exports = __webpack_public_path__ + "static/fonts/ionicons.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/iview/dist/styles/fonts/ionicons.woff2?v=3.0.0
// module id = 88
// module chunks = 83